<template>
  <div class="settings">
    <a-layout>
      <a-layout-header>
        <a href="/" class="logo">
          <img src="../assets/logo.svg" alt="" width="200"/> </a
      ></a-layout-header>
      <a-layout-content class="pad">
        <Atable :panelId="panelId" :password="password" :adminpassword="adminpassword" :baseUrl="baseUrl"/>
      </a-layout-content>
    </a-layout>
  </div>
</template>

<script>

import Atable from './table'
export default {
  props: ['panelId', 'password', 'adminpassword', 'baseUrl'],
  name: 'settings',
  components: {Atable},
  data() {
    return {};
  },
  computed: {},
  watch: {},
  mounted() {
  },
};
</script>

<style scoped lang="sass">

  .pad 
    padding: 30px
</style>
